import { InvoiceSource } from "./invoice";

export enum CatalogItemType {
    SERVICE = "service",
    GOOD = "good",
}

export enum CatalogItemSource {
    QUICKBOOKS = "quickbooks",
}

// The items "Account" filter reuses the invoice source as the unified account
// model (Kick = MANUAL). An item belongs to a source when it appears on at
// least one invoice of that source; uncategorized catalog items (never
// invoiced) are surfaced under Kick so newly created items remain visible by
// default. The remaining integration sources (Stripe/Bill/Mercury/Imported)
// will be added here as item import/attach lands for each. The backend
// `sources` filter already supports them all.
//
// QuickBooks is listed, and is in the default set, because the QBO migration
// imports catalog items AND links them from its imported invoice lines: once
// an item appears on a QUICKBOOKS-source invoice it stops being uncategorized,
// so leaving it out would hide every migrated item from the default view.
export const CATALOG_ITEM_ACCOUNT_SOURCES: InvoiceSource[] = [
    InvoiceSource.MANUAL,
    InvoiceSource.QUICKBOOKS,
];

export const DEFAULT_CATALOG_ITEM_ACCOUNT_SOURCES: InvoiceSource[] = [
    InvoiceSource.MANUAL,
    InvoiceSource.QUICKBOOKS,
];

export enum CatalogItemArchivedFilter {
    ACTIVE = "active",
    ALL = "all",
    ARCHIVED = "archived",
}

// Match mode for the Invoices page "Catalog Item" filter, mirroring the
// class filter's any/all/exclude modes (see ClassFilterType).
export enum CatalogItemFilterType {
    ANY_SELECTED = "any_selected",
    ALL_SELECTED = "all_selected",
    EXCLUDE_SELECTED = "exclude_selected",
}

export enum CatalogItemSort {
    NAME_ASC = "name_asc",
    NAME_DESC = "name_desc",
    UNIT_PRICE_ASC = "unit_price_asc",
    UNIT_PRICE_DESC = "unit_price_desc",
    LAST_UPDATED_ASC = "last_updated_asc",
    LAST_UPDATED_DESC = "last_updated_desc",
    INVOICE_COUNT_ASC = "invoice_count_asc",
    INVOICE_COUNT_DESC = "invoice_count_desc",
    TEMPLATE_COUNT_ASC = "template_count_asc",
    TEMPLATE_COUNT_DESC = "template_count_desc",
}

export const DEFAULT_CATALOG_ITEM_SORT = CatalogItemSort.NAME_ASC;

import type {
    CatalogItem,
    CatalogItemPrice,
} from "@common/schemas/domains/catalogItem/catalogItem.schema";
export type {
    CatalogItem,
    CatalogItemClassRow,
    CatalogItemPrice,
    CatalogItemPriceRow,
    CatalogItemRow,
} from "@common/schemas/domains/catalogItem/catalogItem.schema";

export type CatalogItemPriceBase = CatalogItemPrice;
export type CatalogItemBase = CatalogItem;
